import { createContext, useContext } from 'react'

/* Opens the Settings dialog from anywhere in the /app shell.

   Settings is a dialog rather than a route, so there is no link to follow: the
   TopBar menu and the wizard footers both need a way to raise it, and putting
   one dialog instance in AppShell — rather than one per page — means it opens
   without unmounting whatever the user was doing underneath. */
export const OpenSettingsContext = createContext<() => void>(() => {})

export function useOpenSettings(): () => void {
  return useContext(OpenSettingsContext)
}

/* Raised after a save actually lands.

   The import wizard validates against the tenant's settings — auto-create
   switches, date format, tolerance — and caches the report. Without this, a
   user who fixes a setting because the preview complained closes the dialog
   and keeps looking at a report computed before the fix, with the old errors
   still telling them nothing will be created. The wizard listens for this and
   drops the cached report so its validation effect runs again. */
export const SettingsSavedContext = createContext<() => void>(() => {})

export function useSettingsSaved(): () => void {
  return useContext(SettingsSavedContext)
}
